
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ObjectInfoTitle from '../ObjectInfoTitle';
import IsknTelInfo from './IsknTelInfo';
import IsknParList from './IsknParList';
import IsknVlaList from './IsknVlaList';

const IsknTelObject = ({isknDate, objectInfo}) => {

    return (
        <Stack tokens={{childrenGap: 16}}>
            <Stack.Item>
                <ObjectInfoTitle title="LIST VLASTNICTVÍ" />
                <IsknTelInfo
                    data={objectInfo}
                    isknDate={isknDate}
                />
            </Stack.Item>
            <Stack.Item>
                <ObjectInfoTitle title="VLASTNÍCI" />
                <IsknVlaList
                    data={objectInfo}
                    isknDate={isknDate}
                />
            </Stack.Item>
            <Stack.Item>
                <ObjectInfoTitle title="PARCELY" />
                <IsknParList
                    compact={true}
                    data={objectInfo}
                    isknDate={isknDate}
                />
            </Stack.Item>
        </Stack>
    );
}

export default IsknTelObject;
